const COMMON_OPTIONS = [
    {
        label: "Está vazio",
        value: "_null",
    },
    {
        label: "Não está vazio",
        value: "_nnull",
    },
];

export const DYNAMIC_AND_STATIC_DATE_OPTIONS = [
    {
        label: "Maior que",
        value: "greater",
    },
    {
        label: "Maior ou igual que",
        value: "greater_or_equal",
    },
    {
        label: "Menor que",
        value: "less",
    },
    {
        label: "Menor ou igual que",
        value: "less_or_equal",
    },
    {
        label: "Igual a",
        value: "equal",
    },
];

export const typeOfFilters = [
    {
        type: ["string", "text", "input", "email", "inputmultiline", "inputrichtexthtml"],
        options: [
            {
                label: "Igual a",
                value: "_eq",
            },
            {
                label: "Diferente de",
                value: "_neq",
            },
            {
                label: "Contêm",
                value: "_icontains",
            },
            {
                label: "Não Contêm",
                value: "_ncontains",
            },
            {
                label: "Começa com",
                value: "_starts_with",
            },
            {
                label: "Não começa com",
                value: "_nstarts_with",
            },
            {
                label: "Termina com",
                value: "_ends_with",
            },
            {
                label: "Não termina com",
                value: "_nends_with",
            },
            ...COMMON_OPTIONS,
        ],
    },
    {
        type: ["integer", "integer", "float", "decimal", "amount"],
        options: [
            {
                label: "Maior que",
                value: "_gt",
            },
            {
                label: "Maior ou igual que",
                value: "_gte",
            },
            {
                label: "Menor que",
                value: "_lt",
            },
            {
                label: "Menor ou igual que",
                value: "_lte",
            },
            {
                label: "Igual a",
                value: "_eq",
            },
            {
                label: "Diferente de",
                value: "_neq",
            },
            ...COMMON_OPTIONS,
        ],
    },
    {
        type: ["datetime", "timestamp"],
        options: [
            ...DYNAMIC_AND_STATIC_DATE_OPTIONS,
            {
                label: "Diferente de",
                value: "not_equal",
            },
            ...COMMON_OPTIONS,
        ],
    },
    {
        type: ["date"],
        options: [
            ...DYNAMIC_AND_STATIC_DATE_OPTIONS,
            {
                label: "Diferente de",
                value: "not_equal",
            },
            ...COMMON_OPTIONS,
        ],
    },
    {
        type: ["boolean", "selectdropdownm2o", "selectdropdown", "user_created", "user_updated"],
        options: [
            {
                label: "Igual a",
                value: "_eq",
            },
            {
                label: "Diferente de",
                value: "_neq",
            },
            ...COMMON_OPTIONS,
        ],
    },
    {
        type: ["selectmultipledropdown"], // csv multi-select
        options: [{ label: "Inclui", value: "_contains" }, { label: "Não inclui", value: "_ncontains" }, ...COMMON_OPTIONS],
    },
    {
        type: ["listm2m"], // true m2m relation
        options: [{ label: "É um dos", value: "_in" }, { label: "Não é um dos", value: "_nin" }, ...COMMON_OPTIONS],
    },
    {
        type: ["treatment_provided", "services_provided"],
        options: [
            {
                label: "Igual a",
                value: "_eq",
            },
        ],
    },
    {
        type: ["provided_appointments_last_and_next_session"],
        options: [
            {
                label: "Maior que",
                value: "_gt",
            },
            {
                label: "Menor que",
                value: "_lt",
            },
            {
                label: "Igual a",
                value: "_eq",
            },
            {
                label: "Diferente de",
                value: "_neq",
            },
            {
                label: "Hoje",
                value: "_eq",
            },
        ],
    },
    {
        type: ["orders_payments_methods"],
        options: [
            {
                label: "Igual a",
                value: "_eq",
            },
            {
                label: "Diferente de",
                value: "_neq",
            },
            ...COMMON_OPTIONS,
        ],
    },
    {
        type: ["orders_payments_date"],
        options: [
            ...DYNAMIC_AND_STATIC_DATE_OPTIONS,
            {
                label: "Diferente de",
                value: "not_equal",
            },
            ...COMMON_OPTIONS,
        ],
    },
];
